/* eslint-disable no-cond-assign */
import classNames from 'classnames';
import { STRING_UTILS } from 'common';
import { isJSON } from 'utils/helperFunctions';
import extensions from './Extensions';
import { REPLACE_SHORT_CODE_REGEX_WP } from './Extensions/helper/regex';
import { EditorProvider } from './style';

const { cleanUpTinymceHtmlForTipTap } = STRING_UTILS;

const hasShortCode = (text) => text.match(REPLACE_SHORT_CODE_REGEX_WP);

const onSelectionUpdate = ({ editor }) => {
  const editorValue = editor.getHTML();
  if (hasShortCode(editorValue)) {
    [...new Set(hasShortCode(editorValue))].forEach((element) => {
      editor.commands.setSearchTerm(element);
      editor.commands.setReplaceTerm(element);
      editor.commands.replaceAll();
    });
  }
};

const RichEditor = ({
  content,
  onChange,
  getEditor,
  className,
  editable = true,
  children,
  setError,
  validCharCount,
  ...props
}) => (
  <EditorProvider
    className={className}
    editorProps={{
      attributes: { class: classNames('editor') },
    }}
    extensions={extensions}
    autofocus={false}
    editable={editable}
    content={isJSON(content) ? JSON.parse(content) : cleanUpTinymceHtmlForTipTap(content)}
    onCreate={({ editor }) => {
      getEditor?.(editor);
      onSelectionUpdate({ editor });
    }}
    onSelectionUpdate={onSelectionUpdate}
    onUpdate={({ editor }) => {
      const editorValue = editor.getJSON();
      const hasError =
        editorValue.content?.[0].content?.[0].text.length < validCharCount || !editorValue.content?.[0].content;

      if (hasError && validCharCount) {
        setError('description', { message: 'Description is required' });
        return;
      }
      onChange?.(JSON.stringify(editorValue));
    }}
    {...props}
  >
    {children}
  </EditorProvider>
);

export default RichEditor;
